import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ContactFormValues } from "../../Types/types";
import { toast } from "react-toastify";

const NewsLetter = () => {
  const initialValues: ContactFormValues = {
    name: "",
    phone: "",
    email: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    phone: Yup.string().required("Phone Number is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-20 py-10 sm:py-28">
      <div className="relative group">
        <svg
          viewBox="0 0 1193 379"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full hidden sm:block"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1091.52 65.049C1070.86 65.4954 1062.48 65.6765 1051.65 45.5748C1046.56 36.1231 1040.93 25.6657 1033.22 14.7168C1026.41 5.03736 1014.75 0 1002.71 0H33.8513C15.1558 0 0 14.7746 0 33V172V290V346C0 364.225 14.7747 379 33 379H228.245H256.274H1159.15C1177.84 379 1193 364.225 1193 346V109C1193 84.6995 1172.79 65 1147.87 65H1110.42C1103.11 64.7983 1096.9 64.9327 1091.52 65.049Z"
            fill="#173F84"
          />
        </svg>

        <div className="w-full pl-5 sm:pl-10 pr-5 sm:pr-20 py-14 flex flex-col sm:flex-row justify-between sm:absolute bottom-0 h-full bg-primary sm:bg-transparent">
          <div className="flex flex-col justify-center sm:w-[50%] mb-4 sm:mb-0">
            <div className="relative mb-9 lg:mb-4 xl:mb-9 ml-5 lg:ml-0">
              <h3 className="poppins-regular text-primary z-20 relative">
                Con<span className="text-white"> tact Now</span>
              </h3>
              <div className="size-16 bg-[#ffff] rounded-full absolute -top-5 -left-5"></div>
            </div>
            <h2 className="montserrat-bold text-xl sm:text-2xl text-white mb-5 lg:mb-3 xl:mb-5">
              Take the Next Step with John Bostjancic
            </h2>
            <p className="text-white montserrat-regular">
              Leverage 30+ years of expertise in finance, risk management, and
              organizational transformation.
              <br/>
              <span className="montserrat-semibold">
                Schedule a consultation today{" "}
              </span>
            </p>
          </div>
          <div className="flex flex-col justify-center sm:w-[40%]">
            <p className="montserrat-regular text-lg text-white mb-4 lg:mb-2 xl:mb-4">
              Get Started Free
            </p>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={() => console.log("submitted")}
            >
              <Form className=" flex flex-col relative z-10">
                <div>
                  <div className=" sm:flex gap-4">
                    <Field
                      className="py-4 px-4 rounded-full bg-[#E7E9FF] mb-3 w-full"
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Your Name"
                    />
                    <ErrorMessage
                      name="name"
                      className="text-red-500 text-sm"
                    />
                    <Field
                      className="py-4 px-4 rounded-full bg-[#E7E9FF] mb-3 w-full"
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Your Phone Number"
                    />
                  </div>
                  <ErrorMessage name="phone" className="text-red-500 text-sm" />
                  <Field
                    className="py-4 px-4 rounded-full bg-[#E7E9FF] mb-3 w-full"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email Address"
                  />
                  <ErrorMessage name="email" className="text-red-500 text-sm" />
                  <button
                    className="px-4 py-4 bg-secondary rounded-full text-white montserrat-meduim text-xl w-full hover:bg-white hover:text-black transition-all duration-300"
                    type="submit"
                  >
                    Contact Us
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
        <div className="size-[400px] bg-white p-14 rounded-full absolute bottom-6 left-6 bg-opacity-5 group-hover:scale-110 transition-all duration-300 z-20">
          <div className="size-full bg-white p-14 rounded-full bg-opacity-5 group-hover:scale-110 transition-all duration-300 delay-100">
            <div className="size-full bg-white rounded-full bg-opacity-5 group-hover:scale-110 transition-all duration-300 delay-300"></div>
          </div>
        </div>

        <div className="size-6"></div>
      </div>
    </div>
  );
};

export default NewsLetter;
